<div class=" filter_content">
	<div class="form-group kt-form__group row">
		<div class="col-lg-3 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control" placeholder="Gün Sayısı" [(ngModel)]="selectedLastNumberDayObj">
				<mat-option *ngFor="let approvalDateFilter of approvalDateFilters"
							[value]="approvalDateFilter"
							(click)="onSelectedNumberOfDays(approvalDateFilter.value)">
					{{approvalDateFilter.key}}
				</mat-option>
			</mat-select>
		</div>
		<!--Onay bekleyen taleplerim ve Geçmiş Talepleim sayfasında olacak sadece-->
		<div class="col-lg-9" [hidden]="(productList | async).length < 1">
			<div class="pull-right">
				<button type="button" (click)="btnSelectedRejected()" class="btn btn-danger">{{ 'FE.APPROVALS.BUTTONS.CANCELSELECTED' | localize }}</button>
			</div>
		</div>
	</div>
</div>

<div [hidden]="(productList | async).length < 1">
	<div class="kt-widget5">
		<div class="kt-widget5__item ng-star-inserted">
			<div class="kt-widget5__content checkbox_content">
				<label class="kt-checkbox kt-checkbox--primary">
					<input type="checkbox" #selectProducts (click)="checkboxSelectAll(selectProducts)"> {{ 'FE.APPROVALS.CHECKBOXS.SELECTALL' | localize }}
					<span></span>
				</label>
			</div>
			<div class="kt-widget5__content">
				<div class="kt-widget5__stats">
					<span class="kt-widget5__sales text-center">
						{{ 'FE.APPROVALS.GRID.TOTALDECI' | localize }} : <strong>{{sumDeci | async}}</strong>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngFor="let product of (productList | async)" class="myPenReqPlist">
		<div class="row bottom-border-1px margin-top-10 myPenReqPRow" #pendingPRow>
			<div class="col-md-1 margin-bottom-10 myPenReqPRowEdit-col edit-col">
				<label class="kt-checkbox kt-checkbox--primary pChckbx" placement="top" ngbTooltip="Seç" ngbTooltipClass="kt-tooltip">
					<input type="checkbox" [(ngModel)]="product.isChecked" name="checkboxName">
					<span></span>
				</label>
				<a href="javascript:void(0)" (click)="openImage(product.productCode,product.productName)">
					<img photoUrl alt="" class="kt-widget7__img" width="60%" [attr.src]="getPhotoUrl(product.productCode)" alt="">
				</a>
			</div>
			<div class="col-md-3 margin-bottom-10">
				<span style="display:none" class="myPenReqOrderDetailsId">{{product.orderDetailsId}}</span>
				<span style="display:none" class="myPenReqTwinOrderDetailsId">{{product.twinOrderDetailsId}}</span>
				<a class="kt-widget5__title code"><strong>{{product.productCode}}</strong></a><br>
				<span class="kt-widget5__desc name">{{product.productName}}</span><br>
				<div class="kt-widget5__info">
					<span class="kt-font-info businessUnitName">{{product.productBusinessUnitName}}</span>,
					<span class="kt-font-info brand">{{product.productBrand}}</span>
					<span class="kt-font-danger deci">&nbsp;*{{product.productDeci}} {{ 'FE.APPROVALS.GRID.DECI' | localize }}</span>
				</div>
				<div class="kt-widget5__info sktLot" *ngIf="product.variationId > 0">
					<span *ngIf="product.expirationDate"><strong>{{ 'FE.APPROVALS.GRID.EXPIRATIONDATE' | localize }} :</strong>{{product.expirationDate}} </span>
					<span *ngIf="product.expirationDate && product.lot"> - </span>
					<span *ngIf="product.lot"><strong>{{ 'FE.APPROVALS.GRID.LOT' | localize }} :</strong>{{product.lot}} </span>
					<span *ngIf="product.lot && product.barcode"> - </span>
					<span *ngIf="product.barcode"><strong>{{ 'FE.APPROVALS.GRID.BARCODE' | localize }} :</strong>{{product.barcode}} </span>
					<!--<span><strong>SKT :</strong>12.12.2020</span>
					<span> - </span>
					<span><strong>LOT :</strong>12.12.2020</span>
					<span> - </span>
					<span><strong>BARKOD :</strong>12.12.2020</span>-->
				</div>
			</div>
			<div class="col-md-2 margin-bottom-10">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.DATE' | localize }}</span><br>
				<span class="kt-widget5__number date"><strong>{{product.orderDate}}</strong></span><br>
			</div>
			<div class="col-md-2 margin-bottom-10">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.SOURCEADDRESS' | localize }} </span><br>
				<span class="kt-widget5__number sourceAddress"><strong>{{product.sourceAddressName}}</strong></span>
			</div>
			<div class="col-md-2 margin-bottom-10">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.DESTINATIONADDRESS' | localize }}</span><br>
				<span class="kt-widget5__number targetAddress"><strong>{{product.toAddressName}}</strong></span>
			</div>
			<div class="col-md-1 margin-bottom-10 stock">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.ORDEREDQTY' | localize }}</span><br>
				<input disabled class="form-control form-control-sm orderAmount" type="number" value="{{product.qty}}" #orderAmount (click)="onClickOrderAmount(orderAmount)" (change)="onChangeOrderAmount(orderAmount)" placeholder="{{ 'FE.APPROVALS.GRID.COLUMN.PLACEHOLDERS.ORDEREDQTY' | localize }}">
			</div>
			<div class="col-md-1 btnMyPendingReqRejectAndStatus">
				<button class="btn btn-success btn-pill btn-block btn-sm" (click)="btnRejectForAProject(2,product, pendingPRow)" placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.BUTTONS.DELETEORDER' | localize }}">
					<i class="fa fa-trash"></i>
				</button>
				<button class="btn btn-primary btn-pill btn-block btn-sm" (click)="btnApprovalStatus(product.approvalUsers,product.approvalUsersHasPersonInCharge)">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.BUTTONS.STATUS' | localize }} <i class="fa fa-info-circle"></i></button>
			</div>
		</div>
	</div>
</div>

<div *ngIf="(productList | async).length < 1">
	<h5 class="text-center">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.NOTFOUND' | localize }}</h5>
</div>




